import { useContext, useEffect, useRef, useState } from 'react';
import { matchPath, useLocation } from 'react-router';

import { UserContext } from 'Context/user';

import { PATH_UNSUBSCRIBE } from 'Utilities/routing';

import { postConsentDecision } from 'Components/CookieBanner/consentService';
import { getStoredConsent, hasStoredConsent } from 'Components/CookieBanner/cookieConsent.helpers';

export const AUTH_RETURN_PARAMS = ['authorization_code', 'refreshToken', 'token'];

const PATHS_WITH_NON_AUTH_TOKEN = [PATH_UNSUBSCRIBE];

const getAuthReturnParams = (pathname: string) => {
  const hasNonAuthToken = PATHS_WITH_NON_AUTH_TOKEN.some(
    (path) => matchPath(pathname, { exact: true, path }),
  );

  return hasNonAuthToken ? AUTH_RETURN_PARAMS.filter((param) => param !== 'token') : AUTH_RETURN_PARAMS;
};

export const useSignInConsent = () => {
  const { userState: user } = useContext(UserContext);
  const location = useLocation();
  const hasPosted = useRef(false);

  const [isAuthReturn] = useState(() => {
    const params = new URLSearchParams(location.search);
    return getAuthReturnParams(location.pathname).some((param) => params.has(param));
  });

  const isSignedIn = Number.isInteger(user?.id);

  useEffect(() => {
    if (!isAuthReturn || !isSignedIn || hasPosted.current || !hasStoredConsent()) {
      return;
    }

    hasPosted.current = true;
    postConsentDecision(getStoredConsent(), 'sign_in');
  }, [isAuthReturn, isSignedIn]);
};
